export default __webpack_public_path__ + "static/media/chainlink-link-logo.24598efa.svg";